import { NgModule } from '@angular/core';
import { PrizmCalendarRangeComponent } from './calendar-range.component';

/**
 * @deprecated
 * use standalone
 * */
@NgModule({
  imports: [PrizmCalendarRangeComponent],
  exports: [PrizmCalendarRangeComponent],
})
export class PrizmCalendarRangeModule {}
